import React from 'react';
import packageInfo from '../package.json';

function Footer() {
    return (
        <footer className="mt-auto border-t border-slate-200 bg-white px-6 py-3">
            <div className="mx-auto flex max-w-7xl items-center justify-between text-xs text-slate-400">
                <span>© {new Date().getFullYear()} Graphcom — Signage Cloud</span>
                <span className="font-mono tabular-nums">v{packageInfo.version}</span>
            </div>
        </footer>
    );
}

export default Footer;
